import { createFileRoute } from '@tanstack/react-router'
import { useReport } from '@/hooks/use-report'
import { NestedReportPending } from './-components/shared/nested-report-pending'
import { ReportComponent } from './-components/report/report'

export const Route = createFileRoute('/_app/jobs/$jobId/report')({
  component: RouteComponent,
  pendingComponent: NestedReportPending,
  // SHOWN IMMEDIATELY, and held no longer than it has to be. The router's defaults are `pendingMs: 1000` /
  // `pendingMinMs: 500`: a navigation whose loaders resolve inside a second therefore renders NOTHING new and the
  // route you came from stays on screen — which on a phone means the NAV STACK cannot push, because the level it
  // would push is the route being rendered (see useRenderedPathname) and that is still the old one. Measured on a
  // device as "tapping an integrant only marks it selected; the report never opens" — the search params commit at
  // once (hence the selection) while the screen sits on the list, and tapping again "works" only because the
  // queries are cached by then. At 0/0 the skeleton is there for the first frame of the push and gone the moment
  // the data is, so a cached navigation costs at most one frame of it.
  pendingMs: 0,
  pendingMinMs: 0,
})

function RouteComponent() {
  const context = Route.useRouteContext()
  const { report, isFetching } = useReport(context.reportQueryOptions)
  return <ReportComponent report={report} isFetching={isFetching} />
}
